import React from 'react';

import { useFeatureDisclaimers } from 'hooks/use-feature-disclaimers';

import { Wrapper } from './disclaimer.styled';

const Disclaimer = () => {
  const { featureDisclaimers } = useFeatureDisclaimers();
  const { copyrightAndTrademark, reservedRights } = featureDisclaimers || {};

  if (!copyrightAndTrademark?.locale || !reservedRights?.locale) {
    return null;
  }

  return (
    <Wrapper testID="branding-disclaimer">
      {copyrightAndTrademark?.locale}
      {reservedRights?.locale}
    </Wrapper>
  );
};

export default Disclaimer;
